import * as Scrivito from "scrivito";

export const googleMapsApiKey = () => {
  const root = Scrivito.Obj.root();
  if (!root) {
    return "";
  }

  return root.get("googleMapsApiKey");
};
